<template>
  <Gauge
    :score="score"
    :item-id="itemId"
    :title="title"
    :request-status="requestStatus"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import Gauge from '@/components/cards/models/Gauge';
import { mapActions } from 'vuex';
import sentimentModel from '@/mixins/sentiment-model';
import EventBus from '@/utils/event-bus';
import { POST_FIELDS, OPERATION, DATE_PORTION } from '@/services/charts-service';

export default {
  name: 'SentimentGauge',
  components: {
    Gauge,
  },
  mixins: [
    sentimentModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
    ownerPosts: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      score: { value: 0 },
      requestStatus: 'loading',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getTimeSeries',
        params: {
          datePortion: DATE_PORTION.BY_YEAR,
          grouping: [POST_FIELDS.POLARITY],
          operators: this.operation,
        },
      })
        .then(response => {
          const score = this.sentimentSeriesToScore(response);
          this.score = { value: score };
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(() => {
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

